import {call, put, takeLatest} from 'redux-saga/effects';
import {
    USER_PREFERENCE_QUERY_START,
    UserPreferenceQueryStartAction,
    getUserPreferenceQuerySuccessAction,
    getUserPreferenceQueryFailedAction
} from "../actions/UserPreferenceAction";
import ApiUtil from "src/utils/ApiUtil";
import { setCurrentCountryCodeAction } from "src/actions/CurrentCountryCodeQueryAction";

export function* getUserPreference(action: UserPreferenceQueryStartAction) {
    try {
        let parameters: any = {};
        // @ts-ignore
        const response = yield call(ApiUtil.callApiWithTimeout, "getuserpreference", parameters);

        yield put(getUserPreferenceQuerySuccessAction(response));
        let currentCountryCode: string = response.currentCountryCode;
        yield put(setCurrentCountryCodeAction(currentCountryCode));
    } catch (error) {
        console.error("Call API getuserpreference error" + error)
        yield put(getUserPreferenceQueryFailedAction());
        return;
    }
}

export default function* userPreferenceQuery() {
    yield takeLatest(USER_PREFERENCE_QUERY_START, getUserPreference);
}
